// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class APIKey extends Resource {
    basePath: string = 'services/integrations/general/api-keys/';

    objectPath: string = 'services/integrations/general/api-keys/{ident}/';
}
